/* @flow */

import { compose } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import {
  getEventName,
  getEventOnboardingPicture,
} from '@e180/domain/lib/event/util';

import OnboardingIntroBackgroundDumb from './OnboardingIntroBackgroundDumb';
import withFeatureDecisions from 'src/shared/app/feature/component/withFeatureDecisions';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  // Self passed
  intl: intlShape,
  featureDecisions: Object,
};

const mapStateToProps = (
  state: State,
  { intl, featureDecisions }: Props,
): Object => {
  const event = getEventSafely(state);
  const eventName = getEventName(event, intl.locale);
  const backgroundImage = getEventOnboardingPicture(event);
  const isVideoCallEnabled = featureDecisions.isVideoCallEnabled();

  return {
    eventName,
    backgroundImage,
    isVideoCallEnabled,
  };
};

export default compose(
  injectIntl,
  withFeatureDecisions,
  connect(mapStateToProps),
)(OnboardingIntroBackgroundDumb);
